var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale-manage",style:({ height: `${_vm.windowHeight}px` })},[_c('iframe',{ref:"iframe",attrs:{"id":"iframeWin","src":_vm.iframeUrl,"height":"100%","frameborder":"no","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }